import clsx from 'clsx'
import React from 'react'
import MediaAvatar from '../MediaAvatar'
import useStyles from './styles'

interface AvatarsRowProps {
  user: any
  users: Array<any>
  selectUser: Function
}

const AvatarsRow: React.FC<AvatarsRowProps> = ({ user, users, selectUser }) => {
  const classes = useStyles()

  const handleUserClick = React.useCallback(
    user => {
      selectUser(user)
    },
    [selectUser]
  )

  return (
    <div className={classes.root}>
      {users.map(u => (
        <MediaAvatar
          key={u?.id}
          user={u}
          hideCard
          onClick={() => handleUserClick(u)}
          className={clsx(
            classes.avatar,
            u?.id === user?.id && classes.selectedUser
          )}
        />
      ))}
    </div>
  )
}
export default AvatarsRow
